import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Blog from "./pages/Blog";
import BlogPost from "./components/blog/BlogPost";
import Pricing from "./pages/Pricing";
import Navbar from "./layout/Navbar";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Industries from "./pages/Industries";

const App = () => {
  return (
    <Router>
      <Layout />
    </Router>
  );
};

const Layout = () => {
  const location = useLocation();
  
 
  const isNavbarColored = location.pathname !== "/";

  return (
    <>
      <Navbar className={isNavbarColored ? "navbarColored border-bottom" : "border-0"} />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:titleSlug" element={<BlogPost />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
    </>
  );
};

export default App;